<template>
    <div v-if="transaction">
        <transaction-link
            :transaction-uuid="transaction.uuid"
            :class="{ 'text-error': transaction.deleted, 'text-primary': !transaction.deleted }"
        >
            {{ transaction.transactionName }}
        </transaction-link>
    </div>
</template>

<script setup lang="ts">

import {computed, provide, ref, watch} from 'vue'
import TransactionLink from '@/transaction/TransactionLink.vue'
import {getTransactionByUuid} from '@/transaction/transaction.service'

const props = defineProps({
    params: {
        type: Object as () => {
            data: any,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const transaction = ref()
const draft = computed(() => props.params?.data)

watch(
    () => draft.value?.editTransactionUuid,
    async (transactionUuid) => {
        if (transactionUuid) {
            transaction.value = await getTransactionByUuid(transactionUuid)
        }
    }, {immediate: true}
)

</script>

<style scoped>

</style>